import type { Location } from 'found';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { recordCampaignImpression } from '../actions/user.actions';
import { isOnStripeSchoolAdminArea } from '../components/StripeSchoolAdmin/isOnStripeSchoolAdminArea';
import { selectIsMeLoaded } from '../reducers/user.selectors';
import { useAppDispatch } from '../store/hooks';
import type { CampaignId } from './campaigns/registry';

// Proactive campaigns that point the user at a destination: reaching it records a
// permanent dismissal, so a campaign pointing at a page the user already found
// never shows. Add an entry here for any new campaign that advertises a navigable target.
export const targetRouteByCampaignId = {
	'school-admin-hint': ({ pathname }: Location) => isOnStripeSchoolAdminArea(pathname),
} satisfies Partial<Record<CampaignId, (location: Location) => boolean>>;

export const useConcludeHintOnTargetRoute = (location: Location) => {
	const isMeLoaded = useSelector(selectIsMeLoaded);
	const dispatch = useAppDispatch();

	// Keyed on `isMeLoaded` so a deep link that renders before `/me` resolves still
	// records. The thunk skips a campaign that is already dismissed.
	useEffect(() => {
		if (!isMeLoaded) {
			return;
		}
		for (const [campaignId, isOnTargetRoute] of Object.entries(targetRouteByCampaignId)) {
			if (isOnTargetRoute(location)) {
				dispatch(recordCampaignImpression({ campaignId, action: 'dismiss' }));
			}
		}
	}, [location, isMeLoaded, dispatch]);
};

export default useConcludeHintOnTargetRoute;
